import React from 'react';
export const EmotionalTransition: React.FC = () => {
  return <section className="py-20 bg-blue-900 text-white" data-id="element-49">
      <div className="max-w-4xl mx-auto px-4" data-id="element-50">
        <div className="space-y-8 text-lg md:text-xl leading-relaxed font-light" data-id="element-51">
          <p data-id="element-52">
            Sabemos exactamente cómo te sentís. Amás enseñar gimnasia artística,
            ver a tus alumnos progresar y alcanzar nuevas habilidades te llena
            de orgullo. Pero la realidad es que preparar cada clase te consume
            tiempo y energía que preferirías invertir en lo que realmente
            importa: estar presente con tus gimnastas.
          </p>
          <p data-id="element-53">
            Y lo peor es que, aunque dediques horas a preparar tus clases,
            siempre queda esa sensación de que podrías hacerlo mejor. Que
            podrías ser más profesional, más organizado, más eficiente. Mientras
            tanto, ves a otros profesores que parecen tener todo bajo control,
            con planes anuales estructurados y padres satisfechos, y te
            preguntás:{' '}
            <span className="font-semibold italic" data-id="element-54">
              "¿Qué estoy haciendo mal?"
            </span>
          </p>
          <p className="font-medium text-blue-200 text-xl md:text-2xl border-l-4 border-blue-400 pl-6 py-2" data-id="element-55">
            La verdad es que no estás haciendo nada mal. Simplemente te falta un
            sistema. Una estructura probada que te permita organizar todo tu año
            de clases, tener a mano ejercicios progresivos para cada nivel, y
            comunicarte con confianza con las familias de tus alumnos.
          </p>
        </div>
      </div>
    </section>;
};